import { NgModule } from '@angular/core';
import {IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MenuComponent } from './menu/menu.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { HorizontalNavbarComponent } from './horizontal-navbar/horizontal-navbar.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        IonicModule,
        NgSelectModule
    ],
    declarations: [HorizontalNavbarComponent, MenuComponent],
    exports: [HorizontalNavbarComponent, MenuComponent]
})

export class UiModule {}
